/* eslint-disable @angular-eslint/directive-selector, @angular-eslint/directive-class-suffix */

import { computed, Directive, input } from '@angular/core';
import { SingleRenderInSourceDirectiveBase } from 'common-ui';
import { ProductResultRenderTarget, ProductResultRenderTargetComponents } from './ProductResultRenderTarget';

@Directive({
  selector: '[renderInProductResult]',
  standalone: true,
})
export class RenderInProductResultLayoutDirective extends SingleRenderInSourceDirectiveBase {
  public override renderArgs = input<string | undefined>(undefined, { alias: 'renderInProductResultId' });
  public override priority = input<number>(0, { alias: 'renderInProductResultPriority' });
  public readonly target = input<ProductResultRenderTarget, ProductResultRenderTarget | string | undefined>(
    ProductResultRenderTarget.ImagesOverlay,
    {
      alias: 'renderInProductResult',
      transform: (value) => (value as ProductResultRenderTarget) ?? ProductResultRenderTarget.ImagesOverlay,
    },
  );
  protected readonly renderIn = computed(
    () =>
      ProductResultRenderTargetComponents[this.target()] || ProductResultRenderTargetComponents[ProductResultRenderTarget.ImagesOverlay],
  );
}
